(function() {

    const WebFont = require('webfontloader');

    WebFont.load({

        google: {
            families: ['Roboto:latin-ext']
        }
    });
})();

